import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import logo1 from "../../assets/images/brand-logos/desktop-dark.png";
import Img from "../../assets/images/flags/us_flag.jpg";
import Img1 from "../../assets/images/flags/french_flag.jpg";
import Spinner from "../../components/LoadingSpinner/loadingSpinner";
import axios from "axios";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import Cookies from "js-cookie";
import api from "../../api";
import { Cookie } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { getOrCreateSession } from "../../sessionManager";

const Signin = () => {
  const [loading, setLoading] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [cookieLang, setCookieLang] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    general: "",
  });

  function setLanguage(lang) {
    document.cookie = `lang=${lang}; path=/; max-age=31536000`;
    localStorage.setItem("lang", lang);
    // window.location.reload();
  }
/*   useEffect(() => {
    const start = Date.now();

    const spinnerTimeout = setTimeout(() => {
      setShowSpinner(true);
    }, 500);

    const fetchTimeout = setTimeout(() => {
      setLoading(false);
      const elapsed = Date.now() - start;
      if (elapsed < 500) {
        clearTimeout(spinnerTimeout);
      }
    }, 2000);

    return () => {
      clearTimeout(spinnerTimeout);
      clearTimeout(fetchTimeout);
    };
  }, []); */
  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    if (token) {
      navigate("/", { replace: true });
    }
  }, []);
  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      setCookieLang(cookieLang);
      import(`../../lang/signin/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data.default);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.error("Language cookie 'lang' not found.");
    }
  }, []);
  const getDevice = () => {
    const ua = navigator.userAgent;

    if (/mobile/i.test(ua)) return "Mobile";
    if (/tablet/i.test(ua)) return "Tablet";
    return "Desktop";
  };
  const getBrowserInfo = () => {
    const ua = navigator.userAgent;
    let browser = "Unknown";
    let version = "Unknown";

    if (ua.includes("Chrome")) {
      browser = "Chrome";
      version = ua.match(/Chrome\/([\d.]+)/)?.[1];
    } else if (ua.includes("Firefox")) {
      browser = "Firefox";
      version = ua.match(/Firefox\/([\d.]+)/)?.[1];
    } else if (ua.includes("Safari")) {
      browser = "Safari";
      version = ua.match(/Version\/([\d.]+)/)?.[1];
    } else if (ua.includes("Edg")) {
      browser = "Edge";
      version = ua.match(/Edg\/([\d.]+)/)?.[1];
    }

    return { browser, version };
  };
  const getOSInfo = () => {
    const ua = navigator.userAgent;
    let os = "Unknown";
    let version = "Unknown";

    if (ua.includes("Windows")) {
      os = "Windows";
      version = ua.match(/Windows NT ([\d.]+)/)?.[1];
    } else if (ua.includes("Mac OS")) {
      os = "OS X";
      version = ua.match(/Mac OS X ([\d_]+)/)?.[1]?.replace(/_/g, ".");
    } else if (ua.includes("Android")) {
      os = "Android";
      version = ua.match(/Android ([\d.]+)/)?.[1];
    } else if (ua.includes("iPhone")) {
      os = "iOS";
      version = ua.match(/OS ([\d_]+)/)?.[1]?.replace(/_/g, ".");
    }

    return { os, version };
  };

  async function getUserCountryOnce() {
    const cached = localStorage.getItem("userCountry");
    if (cached) return JSON.parse(cached);

    try {
      const ipRes = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipRes.json();

      const lookupRes = await fetch(
        "https://builder.leadsy.pro/lookup_api/v1/" + ipData.ip,
      );

      const lookupData = await lookupRes.json();
      const data = lookupData?.data || {};

      const result = {
        ip: data.ip || ipData.ip,
        city: data.city || "Unknown City",
        region: data.region || "Unknown Region",
        country: data.country || "Unknown",
        timezone:
          data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      const country = lookupData?.data?.country || "us";
      localStorage.setItem("userCountry", JSON.stringify(result));

      return result;
    } catch (e) {
      return {
        ip: "",
        city: "Unknown City",
        region: "Unknown Region",
        country: "US",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    }
  }
  const { browser, version } = getBrowserInfo();
  const { os, version: osVersion } = getOSInfo();
  const init = async () => {
    const locationData = await getUserCountryOnce();

    const leadId =
      Cookies.get(process.env.REACT_APP_LEAD_ID_PLATFORM) ||
      Cookies.get(process.env.REACT_APP_LEAD_ID);
    const payload = {
      url: window.location.href,
      device: getDevice(),
      ip_address: locationData.ip,
      browser_data: navigator.userAgent,
      ...(leadId ? { lead_id: leadId } : {}),
      details: {
        browser: browser,
        browser_version: version,
        operating_system: os,
        operating_system_version: osVersion,
        location: `${locationData.region}`,
        city: locationData.city,
        region: locationData.region,
        country: locationData.country,
        timezone: locationData.timezone,
        use_vpn: false,
      },
    };
    return payload;
  };

  async function updateSessionLead(lead_id, payload) {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_BASE_URL}/tracking/sessions/add`,
        {
          ...payload,
          lead_id: lead_id,
        },
      );
      const data = response.data;
      Cookies.set(`${process.env.REACT_APP_SESSION_ID}`, String(data.data.id));
      Cookies.set(
        `${process.env.REACT_APP_LEAD_ID}`,
        String(data.data.lead_id),
      );
      Cookies.set(
        `${process.env.REACT_APP_SESSION_ID}_expires`,
        String(Date.now()),
      );
      return response;
    } catch (err) {
      console.error("Update session error:", err);
      return null;
    }
  }
  let sessionPromise = null;

  const getSessionId = async (payload) => {
    if (sessionPromise) {
      return sessionPromise;
    }

    sessionPromise = (async () => {
      let sessionId = Cookies.get(process.env.REACT_APP_SESSION_ID);

      const expired =
        !Cookies.get(`${process.env.REACT_APP_SESSION_ID}_expires`) ||
        Date.now() -
          Number(Cookies.get(`${process.env.REACT_APP_SESSION_ID}_expires`)) >
          3600000;

      if (!sessionId || expired) {
        const leadId =
          Cookies.get(process.env.REACT_APP_LEAD_ID_PLATFORM) ||
          Cookies.get(process.env.REACT_APP_LEAD_ID);

        const response = await updateSessionLead(leadId, payload);

        sessionId = response?.data?.data?.id;
      }

      return sessionId;
    })();

    return sessionPromise;

    /*   let sessionId = Cookies.get(process.env.REACT_APP_SESSION_ID);

    const expiredSession = Cookies.get(
      `${process.env.REACT_APP_SESSION_ID}_expires`,
    );

    const isExpired =
      !expiredSession || Date.now() - Number(expiredSession) > 3600000;

    if (!sessionId || isExpired) {
      const leadId =
        Cookies.get(process.env.REACT_APP_LEAD_ID_PLATFORM) ||
        Cookies.get(process.env.REACT_APP_LEAD_ID);

      const response = await updateSessionLead(leadId, payload);

      if (!response) return null;

      sessionId = String(response.data.data.id);
    }

    return sessionId; */
  };

  const trackInteraction = async (
    action,
    element,
    element_value,
    time_start = new Date().toISOString(),
    time_end = new Date().toISOString(),
  ) => {
    try {
      const sessionId = Cookies.get(process.env.REACT_APP_SESSION_ID);

      if (!sessionId) return;

      await api.post(
        `${process.env.REACT_APP_BASE_URL}/tracking/interactions/add`,
        {
          session_id: sessionId,
          action,
          element,
          element_value: element_value || "",
          time_start,
          time_end,
        },
      );
    } catch (error) {
      console.error("Tracking error:", error);
    }
  };
  useEffect(() => {
    const runTracking = async () => {
      /*   const payload = await init();
      await getSessionId(payload); */

      const payload = await init();
      await getOrCreateSession(payload);
      await trackInteraction(
        "view",
        "page_load",
        window.location.href,
        new Date().toISOString(),
        new Date().toISOString(),
      );
    };

    runTracking();
  }, []);

  useEffect(() => {
    const handleClick = async (e) => {
      const button = e.target.closest("button, a");
      if (!button) return;
      const now = new Date().toISOString();

      await trackInteraction(
        "click",
        button.dataset.interaction,
        button.textContent,
        now,
        now,
      );
    };

    const handleBlur = async (e) => {
      if (!["INPUT", "SELECT", "TEXTAREA"].includes(e.target.tagName)) return;

      const now = new Date().toISOString();

      await trackInteraction("input", e.target.name, e.target.value, now, now);
    };

    document.addEventListener("click", handleClick);
    document.addEventListener("blur", handleBlur, true);

    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("blur", handleBlur, true);
    };
  }, []);

  async function trackSession(payload) {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_BASE_URL}/tracking/sessions/add`,
        payload,
      );

      const data = response?.data?.data;
      if (!data) return null;

      Cookies.set(process.env.REACT_APP_LEAD_ID, String(data.lead_id), {
        path: "/",
      });

      Cookies.set(process.env.REACT_APP_SESSION_ID, String(data.id), {
        path: "/",
      });

      Cookies.set(
        `${process.env.REACT_APP_SESSION_ID}_expires`,
        String(Date.now()),
        {
          path: "/",
        },
      );

      return data.id;
    } catch (err) {
      console.error("Tracking session error:", err);
      return null;
    }
  }
  const createSession = async () => {
    const existingSessionId = Cookies.get(process.env.REACT_APP_SESSION_ID);

    if (existingSessionId) {
      return existingSessionId;
    }

    const payload = await init();

    if (!payload) return null;

    return await trackSession(payload);
  };
  const signIn = async () => {
    setLoading(true);

    try {
      const params = new URLSearchParams(window.location.search);
      const paramU = params.get("u");
      const payl = await init();
      const sessionId = await getOrCreateSession(payl);
      //  const sessionId = await createSession();
      const payload = paramU
        ? { login_token: paramU, session_id: sessionId }
        : { login: email, password, session_id: sessionId };

      const response = await api.post(`/accounts/sign-in`, payload);

      const user = response.data.data;

      localStorage.setItem(
        process.env.REACT_APP_LOCAL_TOKEN,
        JSON.stringify({
          token: user.token,
          expiresAt: Date.now() + 10 * 60 * 1000,
        }),
      );
      Cookies.set(
        process.env.REACT_APP_LEAD_ID,
        String(response.data.data.lead_id),
        {
          path: "/",
        },
      );

      localStorage.setItem(
        process.env.REACT_APP_REFRESH_TOKEN,
        user.refresh_token,
      );

      localStorage.setItem(
        process.env.REACT_APP_USER_INFO,
        JSON.stringify({
          user_id: user.id,
          account_id: user.account_id,
          nickname: user.user.nickname,
          personal_code: user.personal_code,
        }),
      );
      const now = new Date().toISOString();
      await trackInteraction("login", "signin_page", `${user.id}`, now, now);
      const redirect = params.get("redirect");

      if (redirect) {
        window.location.href = redirect;
      } else {
        navigate("/");
      }
    } catch (error) {
      setLoading(false);

      setErrors({
        general:
          error.response?.data?.message === "Please verify your credentials"
            ? languageData.error
            : error.response?.data?.message,
      });
    }
  };

  const GoToSignup = () => {
    const params = new URLSearchParams(window.location.search);

    const redirect = params.get("redirect");

    if (redirect) {
      window.location.href = `/portal/signup?redirect=${encodeURIComponent(redirect)}`;
    } else {
      navigate("/signup/");
    }
  };
  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      email: "",
      password: "",
      general: "",
    };

    // Email validation
    if (!email.trim()) {
      newErrors.email = languageData["email-error"];
      isValid = false;
    }

    // Password validation
    if (!password.trim()) {
      newErrors.password = languageData["password-error"];
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramU = params.get("u");

    if (paramU) {
      signIn();
    }
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    await signIn();
  };
  const languageConfig = {
    fr: {
      flag: Img1,
    },
    en: {
      flag: Img,
    },
  };
  const availableLanguages = process.env.REACT_APP_LANGUAGES.split(",")
    .map((lang) => lang.trim())
    .filter(Boolean);

  if (!languageData) {
    return <div></div>;
  }
  return (
    <>
      <Helmet>
        <html lang={cookieLang} dir="ltr" />
      </Helmet>
      <div
        className="header-element country-selector position-absolute top-0 end-0 p-3"
        style={{ zIndex: 1050 }}
      >
        <a
          data-interaction="lang_button"
          aria-label="anchor"
          href="javascript:void(0);"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
        >
          <i className="bx bx-globe fs-3 text-black"></i>
        </a>
        <ul
          className="dropdown-position absolute main-header-dropdown dropdown-menu border-0 dropdown-menu-end"
          data-popper-placement="none"
        >
          {availableLanguages.map((lang) => {
            const config = languageConfig[lang];

            if (!config) return null;

            return (
              <li key={lang}>
                <a
                  href="#"
                  data-interaction="lang"
                  className="dropdown-item d-flex align-items-center"
                  onClick={(e) => {
                    e.preventDefault();
                    setLanguage(lang);
                  }}
                >
                  <span className="avatar avatar-xs lh-1 me-2">
                    <img src={config.flag} alt={lang} />
                  </span>
                  {languageData?.lang?.[lang]}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="page error-bg" id="particles-js">
        <div className="error-page">
          <div className="container-lg">
            <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
              <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-6 col-sm-8 col-12">
                <div className="my-5 d-flex justify-content-center">
                  <img src={logo} alt="logo" className="desktop-logo" />
                  <img src={logo1} alt="logo" className="desktop-dark" />
                </div>
                <div
                  className="card custom-card rectangle2"
                  style={{
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    width: "120%",
                  }}
                >
                  <div className="card-body p-sm-5 p-3 rectangle3">
                    <div className="text-center">
                      <h4 className="mb-1 fs-20" style={{ color: "grey" }}>
                        {languageData.title}
                      </h4>
                      <h4 className="mb-4 fs-16" style={{ color: "grey" }}>
                        {languageData.subtitle}
                      </h4>

                      {errors.general && (
                        <div className="alert alert-danger mb-3" role="alert">
                          {errors.general}
                        </div>
                      )}

                      <div className="btn-list d-flex flex-column gap-3">
                        <form onSubmit={handleSubmit} id="signin_form">
                          <div className="form-group text-start">
                            <label htmlFor="exampleInputEmail1">
                              {languageData.email}
                            </label>
                            <input
                              type="email"
                              name="email"
                              className={`form-control mt-2 ${
                                errors.email ? "is-invalid" : ""
                              }`}
                              id="exampleInputEmail1"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            {errors.email && (
                              <div className="invalid-feedback text-start">
                                {errors.email}
                              </div>
                            )}
                          </div>
                          <div className="form-group text-start mt-3 position-relative">
                            <label htmlFor="exampleInputPassword1">
                              {languageData.password}
                            </label>
                            <input
                              name="password"
                              type={showPassword ? "text" : "password"}
                              className={`form-control mt-2 ${
                                errors.password ? "is-invalid" : ""
                              }`}
                              id="exampleInputPassword1"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                            <span
                              onClick={() => setShowPassword(!showPassword)}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "71%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#555",
                              }}
                            >
                              {showPassword ? (
                                <RiEyeOffLine size={15} />
                              ) : (
                                <RiEyeLine size={15} />
                              )}
                            </span>
                            {errors.password && (
                              <div className="invalid-feedback text-start">
                                {errors.password}
                              </div>
                            )}
                          </div>
                          <div className="form-group form-check text-end fs-14">
                            <a
                              data-interaction="navigate_to_forget_password_button"
                              href="/portal/recover_password"
                              style={{
                                textDecoration: "underline",
                                color: "grey",
                                fontSize: "14px",
                              }}
                            >
                              {languageData.forget_pass}
                            </a>
                          </div>
                          <button
                            data-interaction="signin_button"
                            type="submit"
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#FF6347",
                              borderColor: "#FF6347",
                              width: "100%",
                              margin: "0 auto",
                              display: "block",
                              marginTop: "50px",
                            }}
                          >
                            {languageData.login}
                          </button>

                          <div className="form-group form-check text-center fs-14 mt-2">
                            <a
                              data-interaction="navigate_to_signup_page"
                              onClick={GoToSignup}
                              style={{
                                textDecoration: "underline",
                                color: "grey",
                                fontSize: "14px",
                              }}
                            >
                              {languageData.not_member}
                            </a>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default Signin;
